<template>
  <section class="step-tooltip">
    <div
      class="step-tooltip__text"
      :class="{ 'step-tooltip__text--blue': blue }"
    >
      <FontAwesomeIcon
        icon="info-circle"
        class="step-tooltip__icon"
        :class="{ 'step-tooltip__icon--show': iconVisible }"
      />
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  // Name
  name: 'step-tooltip',

  // Props
  props: {
    blue: Boolean,
    icon: {
      type: String,
      default: 'info-circle'
    },
    iconVisible: Boolean
  }
}
</script>

<style scoped lang="scss">
.step-tooltip {
  position: relative;
  margin: auto;
  margin-top: 20px;
  color: $theme-text-black;
  font-size: 12px;
  text-align: center;

  @include breakpoint('tablet-portrait-up') {
    width: 380px;
    font-size: 16px;
    margin-top: 40px;
  }

  @include breakpoint('tablet-landscape-up') {
    margin-top: 35px;
  }

  @include breakpoint('desktop-up') {
    width: 380px;
    font-size: 14px;
    margin-top: 20px;
    color: $theme-text-blue;
  }

  &__icon {
    font-size: 15px;
    display: none;
    margin-right: 2px;

    @include breakpoint('desktop-up') {
      margin-top: 2px;
      display: inline;
    }
  }

  &__icon--show {
    display: inline;
  }

  &__text {
    display: inline-block;
    line-height: 22px;

    @include breakpoint('tablet-portrait-up') {
      line-height: 24px;
      font-size: 14px;
    }

    &--blue {
      color: $theme-text-blue;
    }

  }
}
</style>
